import Vue from 'vue'
import config from '@/config'
let mixin = {
  data() {
    return {
      lzConfig: config
    }
  },
  methods: {
    goTo(options) {
      this.$router.push(options)
    },
    open(url) {
      window.open(url)
    }
  }
}
Vue.mixin(mixin)



// WEBPACK FOOTER //
// ./src/mixins/index.js